import { FlexColumn, LabeledInput, MaterialIcon } from '@gorila-shared-ui/components';
import { useStyles } from '../../hooks/useStyles';

type Props = {
  user?: string | number;
  password?: string | number;
  onChangeUser?: (value: string) => void;
  onChangePass?: (value: string) => void;
  onSubmit?: () => void;
};

export function LoginForm({ onChangeUser, onChangePass, user, password, onSubmit }: Props) {
  const { theme } = useStyles();

  return (
    <FlexColumn
      centered
      gap={theme.sizing.scale600}
    >
      <LabeledInput
        placeholder={'Usuario'}
        value={user}
        onChange={onChangeUser}
        size={'default'}
        startEnhancer={<MaterialIcon name="account_circle" />}
      />
      <LabeledInput
        placeholder={'Contraseña'}
        value={password}
        onChange={onChangePass}
        type="password"
        size={'default'}
        autocomplete="current-password"
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onSubmit?.();
          }
        }}
        startEnhancer={<MaterialIcon name="lock" />}
      />
    </FlexColumn>
  );
}
